<template>
  <div
    class="signup-page-preview"
    :style="{ backgroundColor: backgroundColor, color: textColor }"
  >
    <!-- Logo -->
    <div class="preview-logo-wrap">
      <img v-if="logoUrl" :src="logoUrl" alt="Business logo" class="preview-logo-img" />
      <div
        v-else
        class="preview-logo-placeholder"
        :style="{ border: `2px dashed ${textColor}`, color: textColor }"
      >
        Logo
      </div>
    </div>
    <!-- Title & Subtitle -->
    <div class="preview-text-block">
      <div class="preview-title" :style="{ color: textColor }">
        {{ title || 'Your Sign Up Title' }}
      </div>
      <div class="preview-subtitle" :style="{ color: textColor }">
        {{ subtitle || 'Your sign up subtitle will appear here' }}
      </div>
    </div>
    <!-- Form fields (static visual) -->
    <div class="preview-form">
      <div class="preview-field" :style="{ borderColor: textColor + '55' }">
        <span class="preview-field-label" :style="{ color: textColor + '88' }">Email</span>
      </div>
      <div class="preview-field" :style="{ borderColor: textColor + '55' }">
        <span class="preview-field-label" :style="{ color: textColor + '88' }">Password</span>
      </div>
      <div class="preview-checkbox-row" :style="{ color: textColor + 'aa' }">
        <div class="preview-checkbox" :style="{ borderColor: textColor + '88' }"></div>
        <span>I agree to the Terms of Service</span>
      </div>
      <div
        class="preview-btn"
        :style="{ backgroundColor: textColor, color: backgroundColor }"
      >
        Sign in &amp; Enrol
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebDisplayPreview',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: null,
    },
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    textColor: {
      type: String,
      default: '#000000',
    },
  },
};
</script>

<style scoped>
.signup-page-preview {
  border-radius: 12px;
  padding: 20px 18px 18px;
  /* Same shadow as the rewards card and counter sign previews. */
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
  width: 312px;
  box-sizing: border-box;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
}

.preview-logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

.preview-logo-img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: 8px;
}

.preview-logo-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  opacity: 0.5;
}

.preview-text-block {
  text-align: center;
  margin-bottom: 14px;
}

.preview-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.3px;
  margin-bottom: 5px;
}

.preview-subtitle {
  font-size: 11px;
  font-weight: 400;
  line-height: 1.5;
  opacity: 0.8;
}

.preview-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview-field {
  border: 1px solid;
  border-radius: 6px;
  padding: 7px 10px;
  height: 32px;
  display: flex;
  align-items: center;
}

.preview-field-label {
  font-size: 11px;
}

.preview-checkbox-row {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 10px;
  opacity: 0.75;
}

.preview-checkbox {
  width: 13px;
  height: 13px;
  border: 1.5px solid;
  border-radius: 3px;
  flex-shrink: 0;
}

.preview-btn {
  border-radius: 6px;
  padding: 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
